import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import Pagination from '../../../components/ui/Pagination';
import EmptyData from '../../../components/ui/EmptyData';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useGiftTemplatesByAdmin } from '../../../hooks/admin/giftCategory.admin';
import GiftTemplateListTable from '../../../components/admin/giftTemplates/GiftTemplateListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewGiftTemplatesPage() {
          const {t} = useTranslation();
          const [searchParams,setSearchParams] = useSearchParams();
          const pageQuery = Number(searchParams.get('page')) || 1;
             
          const { giftCategoryId} = useParams<{ giftCategoryId: string}>();
          const numericgiftCategoryId = giftCategoryId ? parseInt(giftCategoryId) : 0;

          const {data:templates,isError,isLoading} = useGiftTemplatesByAdmin(numericgiftCategoryId,{page:pageQuery});
    
          const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };


  return (
    <Layout title={t("gift_templates")} headline={""}>
         <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateGiftCategory]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_gift_template"
              buttonLinkPath={`/admin/add-giftTemplate/${numericgiftCategoryId}`}
              />
            </PermissionGate>
         </div>
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {templates && 
      (
        templates.data.length===0 
        ?
        <EmptyData/>
        :
      <>
      <GiftTemplateListTable templates={templates?.data}/>
      <Pagination
      handlePagination={handlePagination}
      totalPages={templates.totalPages}
      currentPage={pageQuery}
      />
      </>
      )
      }
    </Layout>
  )
}

export default AdminViewGiftTemplatesPage